import React, { Fragment, ReactNode } from "react"

interface BreadcrumbsProps {
    elements: ReactNode[]
}

export function Breadcrumbs({ elements }: BreadcrumbsProps) {
    if (elements.length === 0) {
        return null
    }

    return (
        <div className="mt-0 mb-1 text-rhino-700 flex-shrink-0">
            {elements.map((element, index, arr) => (
                <Fragment key={index}>
                    {element} {index === arr.length - 1 ? "" : "> "}
                </Fragment>
            ))}
        </div>
    )
}
